import {
  decode,
  encode
} from "./chunk-NI5RSQUI.js";

// src/url.ts
var isWebSocket = (protocol) => protocol.startsWith("ws");
var createUrl = (url) => {
  try {
    if (!url.includes("://")) {
      url = "https://" + url;
    }
    return new URL(url);
  } catch {
    throw new Error("Invalid URL");
  }
};
function decodePot(pot) {
  try {
    return /^[A-Za-z0-9+/]*={0,4}$/.test(pot) ? decode(pot, false) : pot;
  } catch {
    return pot;
  }
}
function toOriginalUrl(proxyUrl) {
  try {
    const url = createUrl(proxyUrl);
    const pot = url.searchParams.get("__pot");
    if (!pot) return proxyUrl;
    const originalUrl = createUrl(decodePot(pot));
    const finalUrl = new URL(url.href);
    finalUrl.protocol = isWebSocket(url.protocol) ? url.protocol : originalUrl.protocol;
    finalUrl.host = originalUrl.host;
    finalUrl.pathname = url.pathname === "/" ? originalUrl.pathname : url.pathname;
    finalUrl.searchParams.delete("__pot");
    return finalUrl.href;
  } catch {
    return proxyUrl;
  }
}
function toProxyUrl(realUrl, proxyOrigin) {
  try {
    const originalUrl = createUrl(realUrl);
    const proxyUrl = createUrl(proxyOrigin);
    const finalUrl = new URL(proxyUrl.href);
    finalUrl.protocol = isWebSocket(originalUrl.protocol) ? originalUrl.protocol : proxyUrl.protocol;
    finalUrl.pathname = originalUrl.pathname;
    finalUrl.search = originalUrl.search;
    finalUrl.hash = originalUrl.hash;
    finalUrl.searchParams.set("__pot", encode(originalUrl.origin, false));
    return finalUrl.href;
  } catch {
    return realUrl;
  }
}
function formatTargetUrl(url) {
  const urlObj = createUrl(url);
  if (!["http:", "https:"].includes(urlObj.protocol)) {
    throw new Error("URL must start with http:// or https://");
  }
  return url;
}
function deletePot(urlOrSearch) {
  try {
    if (urlOrSearch.startsWith("?")) {
      const params = new URLSearchParams(urlOrSearch);
      params.delete("__pot");
      return params.toString() ? `?${params.toString()}` : "";
    }
    const url = new URL(urlOrSearch);
    url.searchParams.delete("__pot");
    return url.href;
  } catch {
    return urlOrSearch;
  }
}
function normalizeUrl(url) {
  try {
    const { origin, pathname } = new URL(url);
    return origin + pathname;
  } catch {
    return url;
  }
}

export {
  decodePot,
  toOriginalUrl,
  toProxyUrl,
  formatTargetUrl,
  deletePot,
  normalizeUrl
};
